/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSupplierWithOrganizationDto } from './CreateSupplierWithOrganizationDto';
import {
    CreateSupplierWithOrganizationDtoFromJSON,
    CreateSupplierWithOrganizationDtoFromJSONTyped,
    CreateSupplierWithOrganizationDtoToJSON,
} from './CreateSupplierWithOrganizationDto';

/**
 * 
 * @export
 * @interface CreateSupplierOrganizationDto
 */
export interface CreateSupplierOrganizationDto {
    /**
     * Organization name
     * @type {string}
     * @memberof CreateSupplierOrganizationDto
     */
    organizationName: string;
    /**
     * Commercial registration number
     * @type {string}
     * @memberof CreateSupplierOrganizationDto
     */
    commercialNumber?: string;
    /**
     * Tax identification number
     * @type {string}
     * @memberof CreateSupplierOrganizationDto
     */
    taxNumber?: string;
    /**
     * Business types
     * @type {Array<string>}
     * @memberof CreateSupplierOrganizationDto
     */
    businessTypes: Array<CreateSupplierOrganizationDtoBusinessTypesEnum>;
    /**
     * Contact info ID
     * @type {number}
     * @memberof CreateSupplierOrganizationDto
     */
    contactInfoId?: number;
    /**
     * List of suppliers to create with the organization
     * @type {Array<CreateSupplierWithOrganizationDto>}
     * @memberof CreateSupplierOrganizationDto
     */
    users?: Array<CreateSupplierWithOrganizationDto>;
}


/**
 * @export
 */
export const CreateSupplierOrganizationDtoBusinessTypesEnum = {
    Manufacturer: 'MANUFACTURER',
    Importer: 'IMPORTER',
    Distributor: 'DISTRIBUTOR'
} as const;
export type CreateSupplierOrganizationDtoBusinessTypesEnum = typeof CreateSupplierOrganizationDtoBusinessTypesEnum[keyof typeof CreateSupplierOrganizationDtoBusinessTypesEnum];


/**
 * Check if a given object implements the CreateSupplierOrganizationDto interface.
 */
export function instanceOfCreateSupplierOrganizationDto(value: object): value is CreateSupplierOrganizationDto {
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('businessTypes' in value) || value['businessTypes'] === undefined) return false;
    return true;
}

export function CreateSupplierOrganizationDtoFromJSON(json: any): CreateSupplierOrganizationDto {
    return CreateSupplierOrganizationDtoFromJSONTyped(json, false);
}

export function CreateSupplierOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSupplierOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationName': json['organizationName'],
        'commercialNumber': json['commercialNumber'] == null ? undefined : json['commercialNumber'],
        'taxNumber': json['taxNumber'] == null ? undefined : json['taxNumber'],
        'businessTypes': json['businessTypes'],
        'contactInfoId': json['contactInfoId'] == null ? undefined : json['contactInfoId'],
        'users': json['users'] == null ? undefined : ((json['users'] as Array<any>).map(CreateSupplierWithOrganizationDtoFromJSON)),
    };
}

export function CreateSupplierOrganizationDtoToJSON(value?: CreateSupplierOrganizationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationName': value['organizationName'],
        'commercialNumber': value['commercialNumber'],
        'taxNumber': value['taxNumber'],
        'businessTypes': value['businessTypes'],
        'contactInfoId': value['contactInfoId'],
        'users': value['users'] == null ? undefined : ((value['users'] as Array<any>).map(CreateSupplierWithOrganizationDtoToJSON)),
    };
}

